var _excluded = ["autoFocus", "name", "component", "length", "value", "onChange", "onComplete", "onSubmit", "onBlur", "inputProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { InputBase } from './InputBase';
import { DigitsContainer } from './InputPin.style';
import { useInputPin } from './useInputPin';
var DIGITS_LENGTH = 6;
var InputPin = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    autoFocus,
    name,
    component = 'label',
    length = DIGITS_LENGTH,
    value: initialValue = '',
    onChange,
    onComplete,
    onSubmit: _onSubmit,
    onBlur,
    inputProps
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    itemsRef,
    values,
    changeFocus: _changeFocus,
    onBackspace: _onBackspace,
    onItemChange,
    onPaste
  } = useInputPin({
    initialValue,
    length,
    autoFocus,
    onChange,
    onComplete
  });
  React.useImperativeHandle(ref, () => ({
    value: values.join('')
  }), [values]);
  return /*#__PURE__*/React.createElement(DigitsContainer, _extends({}, props, {
    as: component,
    length: length
  }), values.map((value, index) => /*#__PURE__*/React.createElement(InputBase, _extends({}, inputProps, {
    index: index,
    key: index,
    autoSelect: true,
    name: name ? "".concat(name, "[").concat(index, "]") : undefined,
    initialValue: value,
    ref: el => {
      itemsRef.current[index] = el;
      return itemsRef.current[index];
    },
    onBackspace: () => _onBackspace(index),
    onChange: (newValue, isPasting) => onItemChange(newValue, isPasting, index),
    onBlur: onBlur,
    onSubmit: () => _onSubmit === null || _onSubmit === void 0 ? void 0 : _onSubmit(values.join(''), index),
    changeFocus: direction => _changeFocus(direction, index),
    onPaste: index === 0 ? onPaste : null
  }))));
});
export { InputPin };
//# sourceMappingURL=InputPin.js.map